import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '@/components/NavigationBar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';

const TermsAndConditionsPage = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFBF5' }}>
      <NavigationBar user={user} />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Back Button */}
        <Button 
          onClick={() => navigate('/')}
          className="mb-6 border border-black bg-white text-black hover:bg-black hover:text-white transition-all"
        >
          ← Back to Home
        </Button>

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Terms and Conditions</h1>
          <p className="text-gray-600 text-sm">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-10 space-y-8">
          <section>
            <h2 className="text-2xl font-bold mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using The Haute Circle website and services, you accept and agree to be bound by the terms 
              and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">2. Membership and Registration</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              To access certain features of our platform, you must register for an account. When you register, you agree to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and promptly update your registration information</li>
              <li>Maintain the security of your password and account</li>
              <li>Accept all responsibility for all activities that occur under your account</li>
              <li>Notify us immediately of any unauthorized use of your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">3. Fractional Ownership</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The Haute Circle facilitates fractional ownership of luxury assets. By participating in fractional ownership, you acknowledge and agree that:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>You will own a fraction of the asset as specified in your purchase agreement</li>
              <li>Usage rights are subject to availability and scheduling policies</li>
              <li>All co-owners share responsibility for maintenance and associated costs</li>
              <li>Assets may be liquidated as per the terms of the ownership agreement</li>
              <li>Returns on investment are not guaranteed</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. Booking and Usage</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              When booking and using assets:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Bookings must be made in advance through our platform</li>
              <li>Cancellation policies apply as specified for each asset</li>
              <li>Users must comply with all usage guidelines and restrictions</li>
              <li>Any damage or misuse will result in charges and potential membership termination</li>
              <li>Insurance requirements must be met as specified</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. Payment Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Payment terms and conditions:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>All payments must be made through approved payment methods</li>
              <li>Prices are subject to change with notice</li>
              <li>Refunds are subject to our refund policy</li>
              <li>Late payments may result in service suspension</li>
              <li>All fees are non-negotiable unless otherwise stated</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">6. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              All content on The Haute Circle website, including but not limited to text, graphics, logos, images, and software, 
              is the property of The Haute Circle or its content suppliers and is protected by intellectual property laws. 
              You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              The Haute Circle shall not be liable for any indirect, incidental, special, consequential, or punitive damages 
              resulting from your use of or inability to use the service. Our total liability shall not exceed the amount 
              you have paid to us in the twelve (12) months prior to the event giving rise to the liability.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">8. Termination</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to terminate or suspend your account and access to our services immediately, without prior 
              notice or liability, for any reason, including but not limited to breach of these Terms. Upon termination, your 
              right to use the service will immediately cease.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">9. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict 
              of law provisions. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the 
              courts in Bengaluru, Karnataka.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">10. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <p className="text-gray-700 font-medium">Email: support@thehautecircle.com</p>
              <p className="text-gray-700 font-medium">Phone: +91 97408 77727</p>
              <p className="text-gray-700 font-medium">Address: 36, ITPL Main Road, Brookefield, Bengaluru, Karnataka, 560037</p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;
